import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  tasks: [],
  task: null,
  comments: [],
  uiFlags: {
    isLoading: false,
  },
  // incrementado a cada fetchTasks — usado para descartar respostas de
  // requisições antigas que chegam fora de ordem após um filtro/período
  // novo já ter sido aplicado (ver actions.js).
  fetchTasksRequestId: 0,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
